import React from 'react';
import PropTypes from 'prop-types';

import {Card, Typography} from 'views/components';

import {translate, Translate} from 'views/module';

const HappinessScoreButton = (props) => {
  const {
    option,
    happinessScore,
    setHappinessScore,
    buttonColor,
  } = props;

  return (
    <>
      <Card
        key={option.value}
        variant='outlined'
        tabIndex={0}
        role="radio"
        aria-checked={happinessScore === option.value}
        aria-label={translate(option.translationKey)}
        data-active={happinessScore === option.value ? '' : undefined}
        onClick={() => setHappinessScore(option.value)}
        sx={{
          'cursor': 'pointer',
          'display': 'flex',
          'flexDirection': 'column',
          'alignItems': 'center',
          'justifyContent': 'center',
          'position': 'relative',
          'borderWidth': '1.5px',
          'borderRadius': '12px',
          'textAlign': 'center',
          'width': '100%',
          'transition': 'all 0.2s ease',
          '&:hover': {
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
            transform: 'scale(1.05)',
            borderColor: '#cbd5e1',
          },
          '&[data-active]': {
            backgroundColor: buttonColor,
          },
          '&:focus': {
            outline: 'none',
            boxShadow: '0 0 0 4px #10a4a033',
          },
          'p': 3,
        }}
      >
        {happinessScore === option.value && (
          <span
            style={{
              position: 'absolute',
              top: 8,
              right: 8,
              width: 12,
              height: 12,
              borderRadius: '50%',
              background: '#10a4a0',
              zIndex: 2,
              display: 'inline-block',
            }}
            aria-hidden="true"
          />
        )}
        <Typography
          component="span"
          role="img"
          aria-hidden="true"
          sx={{
            fontSize: '2.25rem',
            mb: 1,
          }}
        >
          {option.emoji}
        </Typography>
        <Typography
          sx={{
            mt: 1,
            fontSize: '1.1rem',
          }}
        >
          <Translate expression={option.translationKey}/>
        </Typography>
      </Card>
    </>
  );
};

HappinessScoreButton.propTypes = {
  option: PropTypes.object.isRequired,
  happinessScore: PropTypes.string.isRequired,
  setHappinessScore: PropTypes.func.isRequired,
  buttonColor: PropTypes.string.isRequired,
};

export default React.memo(HappinessScoreButton);
